import { render, staticRenderFns } from "./CustomerCorporateForm.vue?vue&type=template&id=a0a546f8&scoped=true"
import script from "./CustomerCorporateForm.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0a546f8",
  null
  
)

export default component.exports